import { Component } from '@angular/core';

@Component({
  selector: 'app-svg-basket-passive',
  styleUrls: ['./basket-passive.component.scss'],
  templateUrl: './basket-passive.component.html'
})
export class BasketPassiveComponent {}
